import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../state/bound.store'

export const useGetCategory = (categoryId?: string) => {
    const { activityCategories } = useBoundStore(
        useShallow((s) => {
            return {
                activityCategories: s.orgConfig?.activityCategories,
            }
        })
    )
    if (!categoryId) return null

    return activityCategories?.find(
        (category) => category.pub_id === categoryId
    )
}
